import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import { ConfigContext } from '../../Context/ConfigContext';
import { Checkbox } from "primereact/checkbox";
import { Skeleton } from 'primereact/skeleton';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import SaleReturnPrint from '../PrintHelper/SaleReturnPrint';


const SalesReturn = () => {
    const toast = useRef(null);
    const { apiUrl, apiHeadersJson, baseurl, store_id, auth_routes } = useContext(ConfigContext);
    const [products, setProducts] = useState([]);
    const [isPrint, setisPrint] = useState(false);
    const [isFree, setisFree] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(1);
    const [saleType, setSaleType] = useState(2);
    const [discountPer, setDiscountPer] = useState(0);
    const [onlineAmount, setOnlineAmount] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [focusedProduct, setFocusedProduct] = useState(null);
    const [Categories, setCategories] = useState([]);
    const [addedProducts, setAddedProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [InvoiceNumber, setInvoiceNumber] = useState('');
    const [listLoading, setListLoading] = useState(true);
    const [addLoading, setAddLoading] = useState(false);
    const [saleLoading, setSaleLoading] = useState(false);
    const [customerId, setCustomerId] = useState('');
    const [customerInput, setCustomerInput] = useState("");
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showOffer, setShowOffer] = useState(false);
    const headers = apiHeadersJson;
    const [Category, setCategory] = useState(null);
    const { sale_return_id, para_store_id } = useParams();
    const inputRefs = useRef([]);
    const [storeInfo, setStoreInfo] = useState([]);
    const navigate = useNavigate();

    //print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1
        }
    };


    const handleKeyboardInput = (num) => {
        if (focusedProduct !== null) {
            const product = addedProducts[focusedProduct];
            if (product) {
                const currentQty = (product.product_qty ?? '').toString();
                const newQty = parseInt(`${currentQty}${num}`, 10);
                handleInputChange(focusedProduct, 'product_qty', isNaN(newQty) ? 0 : newQty);
            }
        }
    };


    const handleClearInput = () => {
        if (focusedProduct !== null) {
            handleInputChange(focusedProduct, 'product_qty', 0);
        }
    };

    const handleBackspaceInput = () => {
        if (focusedProduct !== null) {
            const product = addedProducts[focusedProduct];
            if (product) {
                const currentQty = (product.product_qty ?? '0').toString();
                const newQtyStr = currentQty.slice(0, -1) || '0';
                const newQty = parseInt(newQtyStr, 10);
                handleInputChange(focusedProduct, 'product_qty', isNaN(newQty) ? 0 : newQty);
            }
        }
    };

    const GetOffer = async () => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetOfferInfo?offer_id=1`, { headers });
            const { success, data, message } = response.data;
            if (success) {
                CheckOffer(data[0]);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.error('Error GetOffer data:', error);
            // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 1000 });
        }
    };

    const CheckOffer = (data) => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinutes = now.getMinutes();

        // Extract offer start and end times
        const [startHour, startMinutes] = data.offer_start_time.split(':').map(Number);
        const [endHour, endMinutes] = data.offer_end_time.split(':').map(Number);

        // Convert current time into minutes
        const currentTimeInMinutes = currentHour * 60 + currentMinutes;
        const startTimeInMinutes = startHour * 60 + startMinutes;
        const endTimeInMinutes = endHour * 60 + endMinutes;
        let isOfferActive = false;

        if (startTimeInMinutes < endTimeInMinutes) {
            // Offer within the same day
            isOfferActive = currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
        } else {
            // Offer spans past midnight
            isOfferActive = currentTimeInMinutes >= startTimeInMinutes || currentTimeInMinutes <= endTimeInMinutes;
        }
        if (isOfferActive) {
            console.log('Offer is running');
            setShowOffer(true);
        } else {
            console.log('Offer is not running');
            setShowOffer(false);
        }
    };


    const filteredProducts = Category
        ? products.filter((product) =>
            (product.category_id === Category.category_id) &&
            (product.product_name.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        : products.filter((product) =>
            product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
        );


    const handleAddProductByBarcode = async (value, type) => {
        if (!value) {
            const errorMsg = type === 'barcode' ? 'Barcode is empty' : 'Select Product First';
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: errorMsg,
                life: 1000,
            });
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
            return;
        }

        setAddLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetProductInfoByBarCode`, {
                params: { type, value },
                headers,
            });

            const audio = new Audio(`https://www.mamtafood.com/assets/audio/coin.mp3`);
            audio.play();
            setAddLoading(false);

            const { success, data, message } = response.data;

            if (success) {
                const product = data[0];

                if (product) {
                    // Determine sale rate based on saleType
                    const productRate = saleType === 1 ? product.product_retail_rate : product.product_sale_rate;

                    setAddedProducts((prev) => {
                        let updatedProducts = [...prev];
                        const existingProduct = prev.find((p) => p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0));

                        if (isFree) {
                            const freeProduct = prev.find((p) => p.product_id === product.product_id && p.stock_free != 0);
                            if (freeProduct) {
                                updatedProducts = prev.map((p) =>
                                    p.product_id === product.product_id && p.stock_free != 0
                                        ? { ...p, product_qty: p.product_qty + 1, stock_free: p.stock_free + 1 }
                                        : p
                                );
                            } else {
                                updatedProducts.push({ ...product, product_qty: 1, product_sale_rate: 0, stock_free: 1 });
                            }
                        } else {
                            if (existingProduct) {
                                updatedProducts = prev.map((p) =>
                                    p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0)
                                        ? { ...p, product_qty: p.product_qty + 1 }
                                        : p
                                );
                                const existingProductIndex = prev.findIndex(p => p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0));
                                setFocusedProduct(existingProductIndex);
                            } else {
                                updatedProducts.push({
                                    ...product,
                                    product_qty: 1,
                                    product_sale_rate: productRate || 0,
                                    stock_free: 0
                                });
                                setFocusedProduct(addedProducts.length);
                            }
                        }

                        return updatedProducts;
                    });


                    if (navigator.vibrate) {
                        navigator.vibrate(200);
                    }
                    GetOffer();
                } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Product not found',
                        life: 1000,
                    });
                    if (navigator.vibrate) {
                        navigator.vibrate(500);
                    }
                }
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: message,
                    life: 1000,
                });
            }
        } catch (error) {
            console.error("Error fetching product info:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Unable to fetch product info',
                life: 1000,
            });
            setAddLoading(false);
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
        }
    };

    useEffect(() => {
        // Focus the last added product's input element
        if (focusedProduct !== null && inputRefs.current[focusedProduct]) {
            inputRefs.current[focusedProduct].focus();
            inputRefs.current[focusedProduct].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [focusedProduct]);

    useEffect(() => {
        let barcodeBuffer = '';
        let timer;
        const handleKeyPress = (event) => {
            clearTimeout(timer);

            if (event.key === 'Enter') {
                if (barcodeBuffer) {
                    handleAddProductByBarcode(barcodeBuffer, 'barcode');
                    barcodeBuffer = '';
                }
            } else {
                barcodeBuffer += event.key;
            }

            timer = setTimeout(() => {
                barcodeBuffer = '';
            }, 300);
        };

        window.addEventListener('keypress', handleKeyPress);

        return () => {
            window.removeEventListener('keypress', handleKeyPress);
        };
    }, [handleAddProductByBarcode]);

    const handleRemoveProduct = (index) => {
        setAddedProducts((prev) => prev.filter((_, i) => i !== index));
    };

    const handleCustomerInputChange = (e) => {
        const input = e.target.value;
        setCustomerInput(input);

        if (input.trim() === "") {
            setFilteredCustomers([]);
            setShowDropdown(false);
            setCustomerId("");
            return;
        }

        const filtered = customers.filter(customer =>
            customer.customer_name.toLowerCase().includes(input.toLowerCase())
        );

        setFilteredCustomers(filtered);
        setShowDropdown(filtered.length > 0);

        const existingCustomer = customers.find(customer =>
            customer.customer_name.toLowerCase() === input.toLowerCase()
        );

        if (existingCustomer) {
            setCustomerId(existingCustomer.customer_id);
        } else {
            setCustomerId("");
        }
    };

    const handleSelectCustomer = (customer) => {
        setCustomerInput(customer.customer_name);
        setCustomerId(customer.customer_id);
        setShowDropdown(false);
    };
    const handleMethodChange = (event) => {
        const selectedValue = parseInt(event.target.value, 10);
        setPaymentMethod(selectedValue);
    };
    const handleTypeChange = (event) => {
        const selectedType = Number(event.target.value);
        setSaleType(selectedType);
    };

    const handleInputChange = (index, field, value) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue)) {
            setAddedProducts((prev) =>
                prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
            );
        }
    };

    function generateInvoiceNumber() {
        if (sale_return_id) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: "You Cannot Update the Invice Number", life: 1000 });
            return;
        }
        const prefix = "SR-";
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        const invoiceNumber = prefix + randomNumber;
        setInvoiceNumber(invoiceNumber);
    }

    const handleResetForm = () => {
        setCustomerId('');
        setInvoiceNumber('');
        setAddedProducts([]);
        if (sale_return_id) {
            navigate('/SaleReturnReports')
        }
    };

    useEffect(() => {
        setCustomerId('');
        setInvoiceNumber('');
        setAddedProducts([]);
    }, [store_id]);

    useEffect(() => {
        if (auth_routes.includes('SaleReturnInvoice')) {
            setisPrint(true);
        }
    }, [auth_routes.length]);

    const handleSubmit = async () => {
        const body = {
            sale_return_id: sale_return_id,
            customer_id: customerId,
            customer_name: customerInput,
            invoice_number: InvoiceNumber,
            payment_method: paymentMethod,
            sale_rate_type: saleType,
            cash_amount: paymentMethod === 1 || paymentMethod === 3 ? (paymentMethod === 3 ? totalAmount - onlineAmount : totalAmount) : 0,
            online_amount: paymentMethod === 2 || paymentMethod === 3 ? (paymentMethod === 3 ? onlineAmount : totalAmount) : 0,
            card_amount: paymentMethod === 4 ? totalAmount : 0,
            discount_percentage: discountPer,
            sub_total_amount: subtotalAmount,
            grand_total_amount: totalAmount,
            rows: addedProducts,
            store_id,
        };

        try {
            setSaleLoading(true);
            const response = await axios.post(`${apiUrl}/ReturnManagement/SaleReturn`, body, { headers });
            setSaleLoading(false);
            const { success, message, cr_sale_return_id } = response.data;

            if (success) {
                if (isPrint) {
                    await handlePrint(cr_sale_return_id);
                }
                handleResetForm();
                fetchDropdownData();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 1000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.log('error', error);
            setSaleLoading(false);
        }
    };

    // printcontroller
    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.sale-invoice-container');
        if (!invoiceContainer) {
            alert("Sale return Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules).map(rule => rule.cssText).join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
                <html>
                    <head><style>${styles}</style></head>
                    <body>${invoiceContainer.innerHTML}</body>
                </html>
            `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetSaleReturnInvoice`, { params: { sale_return_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;
            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };

    const fetchDropdownData = async () => {
        try {
            setListLoading(true);
            const [productRes, customerRes, usersRes, storeInfo] = await Promise.all([
                axios.get(`${apiUrl}/Masters/ProductList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/GetCustomerList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/CategoryList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/GetStoreInfo`, { params: { store_id: store_id }, headers }),
            ]);
            setListLoading(false);

            setProducts(productRes.data.data || []);
            setCustomers(customerRes.data.data || []);
            setCategories(usersRes.data.data || []);
            setStoreInfo(storeInfo.data.storePermissions || []);
        } catch (error) {
            setListLoading(false);
            console.error('Error fetching DropdownData:', error);
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, [store_id]);


    const calculateRowTotal = (product) => {
        const productRate = saleType === 1 ? product.product_retail_rate : product.product_sale_rate;
        return productRate * product.product_qty;
    };

    const calculateRowQty = (product) => {
        return product.product_qty;
    };

    // Function to calculate unique items based on product_id
    const calculateItems = () => {
        const uniqueProductIds = new Set(addedProducts.map(product => product.product_id));
        return uniqueProductIds.size;
    };

    const calculateQty = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowQty(product), 0);
    };

    const calculateTotalAmount = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowTotal(product), 0);
    };

    const discountedAmount = calculateTotalAmount();
    const subtotalAmount = discountedAmount;
    const bftotalAmount = discountedAmount - (discountedAmount * discountPer) / 100;
    const totalAmount = Math.round(bftotalAmount);
    const calculatedQty = calculateQty();
    const calculateditems = calculateItems();


    const GetList = async () => {
        try {
            const response = await axios.get(`${apiUrl}/ReturnManagement/GetSaleReturn`, {
                params: { sale_return_id, type: 0 },
                headers
            });
            const { success, data, rows, message } = response.data;
            if (success) {
                setAddedProducts(rows);
                setCustomerId(data[0].customer_id);
                setCustomerInput(data[0].customer_name);
                setInvoiceNumber(data[0].invoice_number);
                if (data[0].payment_method) {
                    setPaymentMethod(parseInt(data[0].payment_method));
                }
                setSaleType(data[0].sale_rate_type);
                setDiscountPer(data[0].discount_percentage);
                setOnlineAmount(data[0].online_amount);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 1000 });
        }
    };

    useEffect(() => {
        if (sale_return_id) {
            GetList();
        }
        GetOffer();
    }, [sale_return_id]);

    const PaymentMethods = [
        { value: 1, label: 'Cash' },
        { value: 2, label: 'Online' },
        { value: 3, label: 'Cash & Online' },
        { value: 4, label: 'Card' },
    ]
    const SaleTypes = [
        { value: 1, label: 'Retailer' },
        { value: 2, label: 'Whole sale' },
    ]

    const checkOnlineAmount = (onlineAmount && addedProducts.length != 0) && (totalAmount < onlineAmount || onlineAmount <= 0) && paymentMethod == 3;

    return (
        <div className="container-fluid" style={{ background: 'hsl(120deg 100% 97.06%)' }}>
            <Toast ref={toast} position="top-right" />
            <motion.div
                className="row pt-3 bg-light"
                style={{ borderBottom: "1px solid #000" }}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.1 }}
            >
                <div className="col-md-7">
                    <div className="d-flex align-items-center justify-content-between flex-wrap" >
                        <h6>Sale Return Entry</h6>
                        {auth_routes.includes('SaleReturnInvoice') && <label htmlFor="print">
                            <Checkbox checked={isPrint} id='print' className="me-2" onChange={(e) => { setisPrint(e.target.checked) }} />
                            Print
                        </label>}
                        {showOffer && <label htmlFor="Free">
                            <Checkbox checked={isFree} id='Free' className="me-2" onChange={(e) => { setisFree(e.target.checked ? true : false) }} />
                            Free
                        </label>}
                        <div className="">
                            <select
                                className="form-select form-select-sm"
                                value={paymentMethod || ""}
                                onChange={handleMethodChange}>

                                <option value="" disabled>
                                    Select a Method
                                </option>
                                {PaymentMethods.map((method) => (
                                    <option key={method.value} value={method.value}>
                                        {method.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {storeInfo?.includes('AmountType') && <div className="">
                            <select
                                className="form-select form-select-sm"
                                value={saleType || ""}
                                disabled={addedProducts.length != 0}
                                onChange={handleTypeChange}>
                                <option value="" disabled>
                                    Select a Type
                                </option>
                                {SaleTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>}
                    </div>
                </div>
                <div className="col-md-2">
                    <button className='btn btn-info btn-sm text-white w-100' onClick={() => window.open(`#/SalesReturn`)}>New Sale Return</button>
                </div>
                <div className="col-md-3">
                    <div className="p-inputgroup flex-1">
                        <IconField iconPosition="left" className='w-100'>
                            <InputIcon className="pi pi-search"> </InputIcon>
                            <InputText placeholder="Search By Product Name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-100' style={{ height: '35px' }} />
                        </IconField>
                    </div>
                </div>
            </motion.div >

            <div className="row">
                <div className="col-md-5 border border-1 bg-light d-flex flex-column" style={{ height: "calc(100vh - 120px)" }}>
                    <motion.div
                        className="flex-grow-1"
                        style={{ overflowY: 'auto' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.1 }}
                    >
                        <table className="table m-0 table-hover table-bordered table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Rate</th>
                                    {showOffer && <th>Free Qty</th>}
                                    <th>Qty</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {addedProducts.length > 0 ? (
                                <tbody>
                                    <AnimatePresence>
                                        {addedProducts.map((product, i) => (
                                            // <tr key={i} className={focusedProduct === i ? 'table-active' : ''}>
                                            <motion.tr
                                                layout
                                                key={product.product_id}
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0, }}
                                                transition={{ duration: 0.1 }}
                                                onClick={() => { Number(product.stock_free) === 0 && setFocusedProduct(i); }}
                                                className={focusedProduct === i ? 'border border-2 border-danger table-active' : ''}
                                            >
                                                <td className="w-25">{product.product_name}</td>
                                                <td>{saleType === 1 ? product.product_retail_rate : product.product_sale_rate}</td>
                                                {showOffer && <td>{product.stock_free}</td>}
                                                <td style={{ width: '130px' }}>
                                                    <div className="d-flex">
                                                        <button
                                                            type="button"
                                                            disabled={product.product_qty <= 1 || product.stock_free !== 0}
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                handleInputChange(i, 'product_qty', product.product_qty - 1)
                                                            }
                                                        >
                                                            <i className="pi pi-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            className="form-control p-1"
                                                            placeholder="Qty"
                                                            value={product.product_qty}
                                                            disabled={product.stock_free !== 0}
                                                            ref={(el) => (inputRefs.current[i] = el)}
                                                            onFocus={() => setFocusedProduct(i)}
                                                            onChange={(e) =>
                                                                handleInputChange(i, 'product_qty', Number(e.target.value))
                                                            }
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-success btn-sm"
                                                            disabled={product.stock_free !== 0}
                                                            onClick={() =>
                                                                handleInputChange(i, 'product_qty', product.product_qty + 1)
                                                            }
                                                        >
                                                            <i className="pi pi-plus"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{calculateRowTotal(product).toFixed(2)}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleRemoveProduct(i)}
                                                    >
                                                        <i className="pi pi-trash"></i>
                                                    </button>
                                                </td>
                                            </motion.tr>
                                        ))}
                                    </AnimatePresence>
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td className="w-25 text-muted" colSpan={6}>
                                            Add Products ..........!
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </motion.div>

                    <motion.div
                        className="row my-3"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <div className="col-md-6">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={customerInput}
                                    onChange={handleCustomerInputChange}
                                    placeholder="Type or select a customer"
                                    onFocus={() => setShowDropdown(filteredCustomers.length > 0)}
                                    onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                />

                                {showDropdown && (
                                    <ul className="list-group position-absolute w-100 shadow bg-white" style={{ maxHeight: "200px", overflowY: "auto", zIndex: 10 }}>
                                        {filteredCustomers.map(customer => (
                                            <li
                                                key={customer.customer_id}
                                                className="list-group-item list-group-item-action small"
                                                onMouseDown={() => handleSelectCustomer(customer)}
                                            >
                                                {customer.customer_name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group">
                                <button
                                    onClick={generateInvoiceNumber}
                                    className="btn bg-primary d-flex align-items-center justify-content-center"
                                    style={{ width: '40px' }}
                                    type="button"
                                >
                                    <i className="pi pi-refresh"></i>
                                </button>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Invoice No"
                                    value={InvoiceNumber}
                                    disabled
                                    style={{ height: '35px' }}
                                />
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        className="row bg-danger mt-auto"
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: "spring", stiffness: 100 }}
                    >
                        <div className="col-md-6">
                            <div className="row mt-1">
                                <div className="col-md-12 d-flex justify-content-between">
                                    <small className="text-light">
                                        Total Products: <strong>{calculateditems}</strong>
                                    </small>
                                    <small className="text-light">
                                        Total Qty: <strong>{calculatedQty}</strong>
                                    </small>
                                </div>

                                {/* Discount Input */}
                                {storeInfo?.includes('Discount') && <div className="col-md-12 mt-2 d-flex align-items-center">
                                    <small className="text-light">Discount (%) :</small>
                                    <input type="number" className="w-25 p-0 ms-2" onChange={(e) => setDiscountPer(e.target.value)} value={discountPer} />
                                </div>}
                                {paymentMethod === 3 && <div className="col-md-12 mt-2 d-flex align-items-center">
                                    <small className="text-light">Online (₹) :</small>
                                    <input type="number" className=" w-25 p-0 ms-2" onChange={(e) => setOnlineAmount(e.target.value)} value={onlineAmount} />
                                    {checkOnlineAmount &&
                                        <small className="text-light ml-2 invalid-amount">
                                            <strong>
                                                Invalid Amount ..!
                                            </strong>
                                        </small>
                                    }
                                </div>}
                                <div className="col-md-12 mt-2">
                                    <small className="text-light">
                                        Total Amount: <strong>₹{totalAmount.toFixed(2)}</strong>
                                    </small>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="row d-flex justify-content-center align-items-center mt-3">
                                <button
                                    className="btn btn-success btn-sm w-75"
                                    onClick={handleSubmit}
                                    disabled={dataLoading || checkOnlineAmount || saleLoading || !InvoiceNumber || addedProducts.length === 0 || (paymentMethod == 3 && !onlineAmount)}
                                >
                                    {dataLoading ? 'Preparing Print....!' : saleLoading ? "Loading..!" : sale_return_id ? "Update" : "Sale Return"}
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row gx-7 gy-7">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, i) => (
                                    <motion.div
                                        key={num}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: i * 0.09 }}
                                        className="col-4"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-outline-light w-100 btn-sm"
                                            key={num}
                                            onClick={() => handleKeyboardInput(num)}
                                        >
                                            {num}
                                        </button>
                                    </motion.div>
                                ))}
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning w-100 btn-sm"
                                        onClick={handleClearInput}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-danger w-100 btn-sm"
                                        onClick={handleBackspaceInput}
                                    >
                                        <i className='pi pi-delete-left'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-2 d-flex flex-column">
                    {listLoading ? (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <Skeleton width="100%" height="calc(100vh - 120px)" className="rounded-0" />
                        </motion.div>
                    ) : (
                        <motion.div
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="flex-grow-1 d-flex flex-column"
                        >
                            <div
                                style={{
                                    maxHeight: "calc(100vh - 120px)",
                                    overflowY: "auto",
                                    padding: "5px",
                                    background: '#fff',
                                    scrollbarWidth: "thin",
                                }}
                                className="d-flex flex-column gap-2"
                            >
                                {Categories.map((category, index) => (
                                    <motion.div
                                        key={index}
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: Number(`0.${index}`) }}
                                    >
                                        <div
                                            onClick={() => setCategory(Category === category ? "" : category)}
                                            style={{
                                                padding: "12px 16px",
                                                cursor: "pointer",
                                                backgroundColor: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                color: Category === category ? "rgb(220 53 69)" : "#ffffff",
                                                boxShadow: Category === category
                                                    ? "0 2px 8px rgba(255, 255, 255, 0.3)"
                                                    : "0 1px 3px rgba(0, 0, 0, 0.2)",
                                                border: Category === category
                                                    ? "2px solid rgb(220 53 69)"
                                                    : "1px solid rgb(220 53 69)",
                                                transition: "all 0.2s ease-out",
                                            }}
                                            className="d-flex align-items-center gap-3"
                                        >
                                            {category.icon && (
                                                <div
                                                    style={{
                                                        width: "28px",
                                                        height: "28px",
                                                        backgroundColor: Category === category
                                                            ? "#d32f2f"
                                                            : "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                    }}
                                                >
                                                    {category.icon}
                                                </div>
                                            )}
                                            <span
                                                style={{
                                                    fontWeight: Category === category ? "700" : "600",
                                                    fontSize: "0.9rem",
                                                    letterSpacing: "0.3px"
                                                }}
                                            >
                                                {category.name}
                                            </span>
                                            {Category === category && (
                                                <div className="ms-auto">
                                                    <i className="pi pi-check" style={{ color: "#d32f2f", fontWeight: "bold" }}></i>
                                                </div>
                                            )}
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </div>

                <div className="col-md-5 p-0">
                    <div className="h-100 rounded-0" style={{
                        background: 'linear-gradient(90deg, #e4e8eb 0%,rgb(250, 250, 250) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        <div
                            style={{
                                flex: 1,
                                overflowY: 'auto',
                                padding: '0px 12px',
                                maxHeight: "calc(100vh - 120px)",
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                        >
                            {listLoading ? (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {[...Array(12)].map((_, i) => (
                                        <motion.div
                                            className="col-4 col-md-4"
                                            key={i}
                                            variants={itemVariants}
                                        >
                                            <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                                {/* <Skeleton className="w-100" style={{ height: '120px', transform: 'none' }} /> */}
                                                <h6 className="card-title text-truncate"><Skeleton width='100%' height='18vh'></Skeleton></h6>
                                                <div className="card-body">
                                                    <Skeleton width="100%" height="20px" className="mb-2" />
                                                    <div className="d-flex justify-content-between">
                                                        <Skeleton width="60px" height="16px" />
                                                        <Skeleton width="40px" height="16px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    ))}
                                </motion.div>
                            ) : (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {/* <small>Rate: {saleType === 1 ? <> ₹{product.product_retail_rate}</> : <> ₹{product.product_sale_rate}</>}</small> */}
                                    {filteredProducts.length > 0 ? (
                                        filteredProducts.map((product, i) => (
                                            <motion.div
                                                layout
                                                key={i}
                                                className="col-4 col-md-4"
                                                initial={{ opacity: 0, scale: 0.95 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.1 }}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                            >
                                                <div
                                                    className={`card h-100 border-0 shadow-sm overflow-hidden position-relative ${product.product_min_alert > product.total_remaining ? 'blink-animation' : ''
                                                        } ${addLoading ? 'pe-none' : ''}`}
                                                    onClick={() => {
                                                        if (addLoading) return;
                                                        handleAddProductByBarcode(product.product_id, 'id');
                                                    }}
                                                    style={{
                                                        cursor: addLoading ? 'wait' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        opacity: addLoading ? 0.7 : 1
                                                    }}
                                                >
                                                    <div className="ratio ratio-1x1 bg-light">
                                                        <img
                                                            src={product.product_image_url}
                                                            loading='lazy'
                                                            className="card-img-top p-2 object-fit-contain"
                                                            alt={product.product_name}
                                                            style={{ transition: 'transform 0.3s ease' }}
                                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                        />
                                                    </div>
                                                    <div className="card-body p-3">
                                                        <h6 className="card-title text-truncate mb-2" style={{ fontSize: '0.9rem' }}>
                                                            {product.product_name}
                                                        </h6>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small">{saleType === 1 ? <> ₹{product.product_retail_rate}</> : <> ₹{product.product_sale_rate}</>}</span>
                                                            <div className="d-flex align-items-center">
                                                                <span className={`badge ${product.product_min_alert > product.total_remaining ? 'bg-danger' : 'bg-secondary'} me-1`}>
                                                                    {product.total_remaining}
                                                                </span>
                                                                {product.product_min_alert > product.total_remaining && (
                                                                    <i className="pi pi-exclamation-circle text-danger small"></i>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {addLoading && !listLoading && (
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            <div className="spinner-border text-primary" role="status"></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </motion.div>
                                        ))
                                    ) : (
                                        <motion.div
                                            className="col-12"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                        >
                                            <div className="text-center py-5">
                                                <i className="pi pi-search text-muted" style={{ fontSize: '2.5rem' }}></i>
                                                <h6 className="mt-3 text-muted">No products found</h6>
                                                <p className="small text-muted">Try changing your search or filters</p>
                                            </div>
                                        </motion.div>
                                    )}
                                </motion.div>)}
                        </div>
                    </div>
                </div>
            </div>
            {isReadyToPrint && <SaleReturnPrint saleDetails={invoiceData} products={printProducts} user={user} isShow={false} />}
        </div >
    );
};

export default SalesReturn;
